import { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  ADD_OBSERVATION_COLUMNS_DATA,
  INVESTIGATION_OBSERVATION_COLUMNS_DATA,
} from "./config";
import { useAlert } from "context/alert";
import { useDispatch, useSelector } from "react-redux";
import {
  createPatientLabResultEntry,
  fetchInvestigationObservationDropDown,
  fetchObservationResultEntryData,
  fetchOnlyOrganismData,
  fetchReportRoleById,
} from "services/resultEntryReportMaster";
import Loader from "components/Common/loader";
import { STALE_TIME } from "utils/constants";
import Swal from "sweetalert2";
import {
  setResultEntryObservations,
  updateResultEntryObservation,
} from "../../../redux/action/result_entry_observation_action";
import { Link, useNavigate } from "react-router-dom";
import zoneLocalStorageId from "utils/zone";
import TitleComponent from "./TitleComponet";
import InvestigationResults from "./InvestigationResults";
import TemplateDropDown from "components/Common/Dropdowns/TemplateDropDown";
import TextEditor from "components/Common/TextEditor/editor";
import Table from "components/Common/Table/index";
import CommentNameDropdown from "components/Common/Dropdowns/CommentNameDropdown";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function constructFormulasForFilledValues(filledValues, observations) {
  const result = observations.filter((observation) => {
    const array = [];
    observation.fields.forEach((field) => {
      const observation = filledValues.find(
        (item) => item.id === parseInt(field.replace("#", "")),
      );
      if (observation) array.push(observation.value);
    });
    if (array.length === observation.fields.length) return true;
    return false;
  });
  // return result;
  return result.map((observation) => {
    let formula = observation.formula;

    observation.fields.forEach((field) => {
      const id = parseInt(field.replace("#", "").replace("@", ""));
      const found = filledValues.find((item) => item.id === id);
      if (found) {
        formula = formula.replace(new RegExp(`#${id}@`, "g"), found.value);
      }
    });

    let observationValue = null;
    try {
      observationValue = eval(formula);
    } catch (error) {
      console.error(`Error evaluating formula: ${observation.formula}`, error);
    }

    return { ...observation, observationValue };
  });
}

function constructFormulaFieldsFromObservations(observation) {
  const departmentKeys = Object.keys(
    observation.department_investigation || {},
  );

  const result = departmentKeys.flatMap((department) => {
    const investigationKeys = Object.keys(
      observation.department_investigation[department] || {},
    );

    return investigationKeys.flatMap((investigation) => {
      return observation.department_investigation[department][
        investigation
      ]?.observations
        .map((item) => ({
          id: item.observation_id,
          department,
          investigation,
          name: item.observation_name.trim(),
          formula: item.observation_formula,
          fields:
            item.observation_formula
              ?.match(/#\d+@/g)
              ?.map((field) => field.trim()) || [],
        }))
        .filter((item) => item.formula);
    });
  });

  return result;
}

const ApprovedModalInsideRow = ({
  onClose,
  rowData,
  handleDocuments,
  documentInfo,
  refetchBussinessReport,
  isOpenObservationValue,
  editObservationValue,
  // searchValue,
  // filters,
  // updateMultipleFilters,
}) => {
  const dispatch = useDispatch();
  const observationDataRedux = useSelector(
    (state) => state.resultEntryObservationReducer,
  );

  const { showAlert } = useAlert();

  const [commentName, setCommentName] = useState();
  const [comment, setComment] = useState("");

  const [showEditor, setShowEditor] = useState(false);

  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [updatedRows, setUpdatedRows] = useState({});
  const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);
  const [filterValue, setFilterValue] = useState();
  const [doctorId, setdoctorId] = useState();
  // const [comment, setComment] = useState("");
  const [investigationId, setInvestigationId] = useState(
    rowData?.investigation_data?.investigation_id,
  );

  // const [commentName, setCommentName] = useState();
  const [commentsMap, setCommentsMap] = useState({});
  const [commentNamesMap, setCommentNamesMap] = useState({});
  const [templateDescription, setTemplateDescription] = useState();
  const [status, setStatus] = useState(null);
  const [selectedInvestigationIds, setSelectedInvestigationIds] = useState([]);
  const [selectedInvestigationId, setSelectedInvestigationId] = useState();
  const [selectedInvestigation, setSelectedInvestigation] = useState(null);
  const [selectedInvestigations, setSelectedInvestigations] = useState([]);
  const [investigationDataMap, setInvestigationDataMap] = useState({});
  const [constructedObservations, setConstructedObservations] = useState([]);
  const [updatedFormulas, setUpdatedFormulas] = useState([]);
  const [filledObservations, setFilledObservations] = useState([]);
  const [template, setTemplate] = useState({});
  const [checkedInvestigations, setCheckedInvestigations] = useState({});

  const [observationData, setObservationData] = useState([]);

  const [isOrganismData, setIsOrganismData] = useState(false);
  const [organismObservations, setOrganismObservations] = useState([]);

  const defaultCheckedInvestigations = useMemo(() => {
    const defaultChecked = {};

    if (observationDataRedux && Object.keys(observationDataRedux).length > 0) {
      Object.entries(observationDataRedux).forEach(
        ([department, investigations]) => {
          Object.entries(investigations).forEach(
            ([investigation_name, observations]) => {
              const investigationKey = `${department}-${investigation_name}`;
              defaultChecked[investigationKey] = true;
            },
          );
        },
      );
    }

    return defaultChecked;
  }, [observationDataRedux]);

  useEffect(() => {
    if (
      Object.keys(defaultCheckedInvestigations).length > 0 &&
      Object.keys(checkedInvestigations).length === 0
    ) {
      setCheckedInvestigations(defaultCheckedInvestigations);
    }
  }, [defaultCheckedInvestigations]);

  const handleCheckboxChange = (key) => {
    setCheckedInvestigations((prev) => ({
      ...prev,
      [key]: !Boolean(prev[key]),
    }));
  };

  const [
    numericValueAcceptableObservations,
    setNumericValueAcceptableObservations,
  ] = useState([]);

  const constructedObservationsRef = useRef([]);

  const auth = useSelector((state) => state.jwtAuthreducer);

  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const onSuccess = (groupedData = {}) => {
    const document = true;
    const message = rowData
      ? "Document updated successfully!"
      : "Document created successfully!";
    showAlert(message, "success");

    const ids = Object.values(groupedData)
      .flat()
      .map((entry) => ({
        appointment_id: entry.appointment_id,
        investigation_id: entry.investigation_id,
      }));

    // refetchBussinessReport();
    onClose(document, ids);
  };

  const onError = () => {
    showAlert("Something went wrong!", "danger");
  };

  const {
    data: listPayment,
    isLoading: isLoadingPayment,
    refetch: refetchPayment,
  } = useQuery(
    [
      "fetch-observation-result-entry",
      rowData?.appointment_id,
      investigationId,
    ],
    () =>
      fetchObservationResultEntryData({
        appointment_id: rowData?.appointment_id,
        investigation_id: investigationId,
      }),
    {
      staleTime: 0,
      select: (res) => {
        const response = res?.data?.data;
        if (response && response.length) {
          res.data.data = response.map((x, index) => ({
            ...x,
          }));
        }
        return res;
      },
      onError: (error) => {
        console.error("Error fetching payments:", error);
        Swal.fire({
          icon: "error",
          title: "Failed to Fetch Data",
          text:
            error?.response?.data?.detail ||
            "Something went wrong while fetching payment data.",
        });
      },
      enabled: !!rowData?.appointment_id && !!investigationId,
    },
  );

  const hasAnyCulture = useMemo(() => {
    if (
      !observationDataRedux ||
      Object.keys(observationDataRedux).length === 0
    ) {
      return false;
    }

    return Object.entries(observationDataRedux).some(
      ([department, investigations]) =>
        Object.entries(investigations).some(
          ([investigation_name, observationWrapper]) =>
            observationWrapper?.investigation_detail?.is_culture === true,
        ),
    );
  }, [observationDataRedux]);

  const isInvestigationCulture = (department, investigationName) => {
    if (!observationDataRedux || !observationDataRedux[department]) {
      return false;
    }

    const investigation = observationDataRedux[department][investigationName];
    return investigation?.investigation_detail?.is_culture === true;
  };

  const {
    data: onlyOrganismData,
    isLoading: isLoadingOnlyOrganism,
    refetch: refetchOnlyOrganismDropDown,
  } = useQuery(["fetch-only-organism-data"], () => fetchOnlyOrganismData(), {
    staleTime: STALE_TIME,
    select: (res) => {
      const response = res?.data?.data;
      if (response && response.length) {
        res.data.data = response.map((x, index) => ({
          ...x,
        }));
      }
      return res;
    },
    onError: (error) => {
      console.error("Error fetching payments:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to Fetch Data",
        text:
          error?.response?.data?.detail ||
          "Something went wrong while fetching payment data.",
      });
    },
    enabled: hasAnyCulture,
  });

  useEffect(() => {
    selectedInvestigationIds.forEach((investigationId) => {
      if (hasAnyCulture) {
        fetchInvestigationObservationDropDown({
          investigation_id: investigationId,
          req_help_data: true,
        })
          .then((res) => {
            const response = res?.data?.data || [];

            setInvestigationDataMap((prevData) => {
              const existingData = prevData[investigationId] || [];

              const combined = [...existingData, ...response];

              const uniqueData = combined.filter(
                (item, index, self) =>
                  index ===
                  self.findIndex(
                    (t) =>
                      t.investigation_id === item.investigation_id &&
                      t.observation_id === item.observation_id,
                  ),
              );

              return {
                ...prevData,
                [investigationId]: uniqueData,
              };
            });
          })
          .catch((error) => {
            console.error("Error fetching investigation data:", error);
            Swal.fire({
              icon: "error",
              title: "Failed to Fetch Data",
              text:
                error?.response?.data?.detail ||
                "Something went wrong while fetching investigation data.",
            });
          });
      }
    });
  }, [selectedInvestigationIds, hasAnyCulture]);

  const handleInvestigationChange = (event) => {
    const selectedId = event.target.value;

    setSelectedInvestigationId(selectedId);
    if (!selectedId) return;

    if (selectedInvestigations.some((item) => item.id == selectedId)) {
      Swal.fire({
        icon: "warning",
        title: "Already Selected",
        text: "This investigation is already added!",
      });
      return;
    }

    const selectedOption = onlyOrganismData?.data?.data?.find(
      (item) => item.id == selectedId,
    );

    if (selectedOption) {
      setSelectedInvestigations((prev) => [
        ...prev,
        {
          id: selectedOption.id,
          name: selectedOption.investigation_name,
        },
      ]);
      setSelectedInvestigationIds((prev) => [
        ...new Set([...prev, selectedOption.id]),
      ]);
    }
  };

  const handleRemoveInvestigation = (id) => {
    setSelectedInvestigations((prev) => prev.filter((inv) => inv.id !== id));
    setInvestigationDataMap((prevData) => {
      const updatedData = { ...prevData };
      delete updatedData[id];
      return updatedData;
    });
  };

  const inputRefs = useRef([]);
  const inputRefsDrug = useRef([]);
  const lastFocusedInput = useRef(null);

  useEffect(() => {
    if (
      isOpenObservationValue &&
      listPayment?.data?.observations?.department_investigation
    ) {
      dispatch(
        setResultEntryObservations(
          listPayment?.data?.observations?.department_investigation,
        ),
      );
    }
  }, [
    isOpenObservationValue,
    listPayment?.data?.observations?.department_investigation,
  ]);

  useEffect(() => {
    let observationOrganismData = [];

    Object.entries(observationDataRedux).forEach(
      ([department, investigations]) => {
        Object.entries(investigations).forEach(
          ([investigation_name, observationWrapper]) => {
            if (
              observationWrapper?.investigation_organism &&
              observationWrapper.investigation_organism.length > 0
            ) {
              observationOrganismData = [
                ...observationOrganismData,
                ...observationWrapper.investigation_organism,
              ];
            }
          },
        );
      },
    );

    if (observationOrganismData.length > 0) {
      setIsOrganismData(true);
      setOrganismObservations(observationOrganismData);

      const organismInvestigationIds = observationOrganismData.map(
        (item) => item.investigation_id,
      );

      const uniqueInvestigationIds = [...new Set(organismInvestigationIds)];

      setSelectedInvestigationIds(uniqueInvestigationIds);

      let allObservationData = [];

      uniqueInvestigationIds.forEach((investigationId) => {
        const investigationData = observationOrganismData.filter(
          (item) => item.investigation_id === investigationId,
        );

        const investigationInfo = onlyOrganismData?.data?.data?.find(
          (item) => item.id === investigationId,
        );

        if (investigationInfo) {
          setSelectedInvestigations((prev) => {
            const exists = prev.some((inv) => inv.id === investigationId);
            if (!exists) {
              return [
                ...prev,
                {
                  id: investigationId,
                  name: investigationInfo.investigation_name,
                },
              ];
            }
            return prev;
          });

          setInvestigationDataMap((prev) => {
            const existingData = prev[investigationId] || [];
            const combined = [...existingData, ...investigationData];

            const uniqueData = combined.filter(
              (item, index, self) =>
                index ===
                self.findIndex(
                  (t) =>
                    t.investigation_id === item.investigation_id &&
                    t.observation_id === item.observation_id,
                ),
            );

            const currentObservationData = uniqueData
              .filter(
                (item) =>
                  (item.observation_value !== undefined &&
                    item.observation_value !== null &&
                    String(item.observation_value).trim() !== "") ||
                  (item.observation_value_mac_reading !== undefined &&
                    item.observation_value_mac_reading !== null &&
                    String(item.observation_value_mac_reading).trim() !== ""),
              )
              .map((item) => ({
                id: item.observation_id,
                parent_investigation_id: item.investigation_id,
                observation_value: item.observation_value || "",
                observation_value_mac_reading:
                  item.observation_value_mac_reading || "",
              }));

            allObservationData = [
              ...allObservationData,
              ...currentObservationData,
            ];

            allObservationData = allObservationData.filter(
              (item, index, self) =>
                index ===
                self.findIndex(
                  (t) =>
                    t.id === item.id &&
                    t.parent_investigation_id === item.parent_investigation_id,
                ),
            );

            setObservationData(allObservationData);

            return {
              ...prev,
              [investigationId]: uniqueData,
            };
          });
        }
      });
    } else {
      setIsOrganismData(false);
      setOrganismObservations([]);
      setSelectedInvestigationIds([]);
      setInvestigationDataMap({});
    }
  }, [observationDataRedux]);

  const {
    data: reportRoleData,
    isLoading,
    refetch: refetchReportRole,
  } = useQuery(
    ["fetch-report-role", jwtAuthreducer.user.employee_code_id],
    () =>
      fetchReportRoleById({
        employee_code_id: jwtAuthreducer.user.employee_code_id,
      }),
    {
      keepPreviousData: false,
      staleTime: STALE_TIME,
      select: (res) => {
        return res;
      },
      onError: (res) => {
        console.error("Error fetching areas:", res);
      },
    },
  );

  const { mutate: addPatientLabResultEntryMutate, isLoading: isLoadingAdd } =
    useMutation({
      mutationFn: createPatientLabResultEntry,
      onSuccess,
      onError,
    });

  const updateRow = useCallback((originalRow, rowId, field, value) => {
    setUpdatedRows((prev) => {
      const newUpdatedRows = {
        ...prev,
        [rowId]: {
          ...originalRow,
          [field]: value,
        },
      };
      setIsSaveEnabled(Object.keys(newUpdatedRows).length > 0);
      return newUpdatedRows;
    });
  }, []);

  const handleSave = (currentRole) => {
    if (
      !observationDataRedux ||
      Object.keys(observationDataRedux).length === 0
    ) {
      console.warn("No data available to save.");
      return;
    }

    const groupedData = {};
    const targetInvestigationId = rowData?.investigation_data?.investigation_id;

    Object.entries(observationDataRedux).forEach(
      ([department, investigations]) => {
        Object.entries(investigations).forEach(
          ([investigation_name, observationWrapper]) => {
            const observations = observationWrapper?.observations || [];

            observations.forEach((obs) => {
              const investigation_id = obs.investigation_id || 0;

              if (investigation_id !== targetInvestigationId) {
                return;
              }

              // if (template?.template_id || !obs.observation_value) {
              //   return;
              // }

              const appointment_id = obs.appointment_id || 0;

              if (!groupedData[appointment_id]) {
                groupedData[appointment_id] = [];
              }

              let investigationEntry = groupedData[appointment_id].find(
                (entry) => entry.investigation_id === investigation_id,
              );

              if (!investigationEntry) {
                investigationEntry = {
                  investigation_id,
                  appointment_id,
                  observation: [],
                };
                groupedData[appointment_id].push(investigationEntry);
              }

              investigationEntry.observation.push({
                observation_id: obs.observation_id,
                gender: obs.patient_details?.gender,
                observation_value: String(obs.observation_value),
                status: currentRole === "SAVE" ? "RESULT_DONE" : currentRole,
                min_reading: obs.min_reading,
                max_reading: obs.max_reading,
                min_critical: obs.min_critical,
                max_critical: obs.max_critical,
                unit: obs.unit,
                barcode_no: obs.barcode_no,
                doctor_id: filterValue,
                comments: stripHtmlTags(comment),
                comment_id: commentName?.comment_id,
                modified_by: auth?.user?.employee_code_id,
                template_id: template?.template_id,
                template_description: template?.template_description,
              });
            });
          },
        );
      },
    );

    const payload = {
      data: Object.values(groupedData).flat(),
    };

    if (payload.data.length > 0) {
      addPatientLabResultEntryMutate(payload, {
        onSuccess: () => onSuccess(groupedData),
        onError,
      });
    }
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleValueChange = useCallback(
    (value, department, investigation, obsId) => {
      const currentConstructedObservations = constructedObservationsRef.current;
      const isDirectChange =
        currentConstructedObservations.findIndex((o) => +o.id === +obsId) > -1;

      if (
        isDirectChange &&
        value?.length &&
        (value[value.length - 1] === "." ||
          (value.includes(".") && value[value.length - 1] === "0"))
      ) {
        const isNumericValue = /^\d+\.?\d*$/.test(value.replace(/\.+$/, ""));
        if (isNumericValue) {
          return;
        }
      }

      // console.table(currentConstructedObservations);

      setFilledObservations((prev) => {
        const obsIndex = prev.findIndex((o) => +o.id === +obsId);
        const formulaIndex = currentConstructedObservations.findIndex(
          (o) => +o.id === +obsId,
        );
        const obs = { id: obsId, value: +value };
        if (formulaIndex > -1) {
          obs.isDirectChange = true;
        }

        if (obsIndex > -1) {
          if (!value) {
            return prev.filter((_, index) => index !== obsIndex);
          } else {
            return prev.map((o, index) => (index === obsIndex ? obs : o));
          }
        } else {
          return [...prev, obs];
        }
      });

      dispatch(
        updateResultEntryObservation(department, investigation, obsId, value),
      );
    },
    [dispatch],
  );

  useEffect(() => {
    if (!constructedObservations.length) {
      const constructedObs = constructFormulaFieldsFromObservations({
        department_investigation: observationDataRedux,
      });
      setConstructedObservations(constructedObs);
      constructedObservationsRef.current = constructedObs;
    }
  }, [observationDataRedux]);

  useEffect(() => {
    const numericValueObservations = [];
    for (const obs of constructedObservations) {
      const constructedObervationIds = obs.fields.map(
        (f) => +f.replace(/[#@]/g, ""),
      );
      numericValueObservations.push(...constructedObervationIds);
    }
    const uniqueNumericValueObservations = [
      ...new Set(numericValueObservations),
    ];
    setNumericValueAcceptableObservations(uniqueNumericValueObservations);
  }, [constructedObservations]);

  useEffect(() => {
    // console.table(filledObservations);
    // console.table(constructedObservations);
    const formulas = constructFormulasForFilledValues(
      filledObservations,
      constructedObservations,
    );
    setUpdatedFormulas((prev) => {
      const newIds = new Set(formulas.map((f) => f.id));
      const removedFormulas = prev.filter((f) => !newIds.has(f.id));
      removedFormulas.forEach(({ department, investigation, id }) => {
        dispatch(
          updateResultEntryObservation(department, investigation, id, ""),
        );
      });

      return formulas;
    });
  }, [filledObservations]);

  useEffect(() => {
    updatedFormulas.forEach((obs) => {
      const { department, investigation, id, observationValue } = obs;

      let value = parseFloat(Number(observationValue));
      let isValueRemoved = false;
      if (isNaN(value)) isValueRemoved = true;

      const formattedValue = +(value < 0 ? value * -1 : value).toFixed(2);

      setFilledObservations((prev) => {
        const obsIndex = prev.findIndex((o) => +o.id === +id);
        const obs = { id, value: formattedValue };
        let updatedFilledObservations;
        if (obsIndex > -1) {
          if (isValueRemoved) {
            updatedFilledObservations = prev.filter(
              (_, index) => index !== obsIndex,
            );
          } else {
            updatedFilledObservations = prev.map((o, index) => {
              // return index === obsIndex ? obs : o;
              if (index === obsIndex) {
                if (o?.isDirectChange) {
                  return o;
                }
                return obs;
              }
              return o;
            });
          }
        } else {
          updatedFilledObservations = [...prev, obs];
        }

        if (JSON.stringify(prev) === JSON.stringify(updatedFilledObservations))
          return prev;
        return updatedFilledObservations;
      });

      dispatch(
        updateResultEntryObservation(
          department,
          investigation,
          id,
          formattedValue,
        ),
      );
    });
  }, [updatedFormulas]);

  const add_observation_columns = useMemo(() => {
    return ADD_OBSERVATION_COLUMNS_DATA(
      handleValueChange,
      inputRefs,
      numericValueAcceptableObservations,
      checkedInvestigations,
      lastFocusedInput,
    );
  }, [inputRefs, checkedInvestigations, lastFocusedInput]);

  const handleValue = (
    rowId,
    newValue,
    parent_investigation_id,
    fieldType = "observation_value",
  ) => {
    // console.log("📥 handleValue CALLED with:", {
    //   rowId,
    //   newValue,
    //   parent_investigation_id,
    //   fieldType,
    // });

    setObservationData((prevData) => {
      if (!prevData || prevData.length === 0) {
        const newRow = {
          id: rowId,
          parent_investigation_id: parent_investigation_id,
          [fieldType]: newValue,
        };
        return [newRow];
      }

      const rowExists = prevData.some(
        (row) => String(row.id) === String(rowId),
      );

      if (rowExists) {
        return prevData.map((row) =>
          String(row.id) === String(rowId)
            ? {
                ...row,
                [fieldType]: newValue,
                parent_investigation_id: parent_investigation_id, // ✅ FIXED HERE
              }
            : row,
        );
      } else {
        const newRow = {
          id: rowId,
          parent_investigation_id: parent_investigation_id,
          [fieldType]: newValue,
        };
        return [...prevData, newRow];
      }
    });
  };

  const investigation_observation_columns = useMemo(() => {
    return INVESTIGATION_OBSERVATION_COLUMNS_DATA(handleValue, inputRefs);
  }, [inputRefs]);

  const handleCommentChange = (departmentName, investigationName, value) => {
    const key = `${departmentName}-${investigationName}`;
    setCommentsMap((prevMap) => ({
      ...prevMap,
      [key]: value,
    }));
  };

  // Handle comment name selection for a specific investigation
  const handleCommentNameChange = (
    departmentName,
    investigationName,
    selectedCommentName,
  ) => {
    const key = `${departmentName}-${investigationName}`;

    if (selectedCommentName === null) {
      // Handle clearing the dropdown
      setCommentNamesMap((prevMap) => {
        const newMap = { ...prevMap };
        delete newMap[key];
        return newMap;
      });

      setCommentsMap((prevMap) => {
        const newMap = { ...prevMap };
        delete newMap[key];
        return newMap;
      });
      return;
    }

    setCommentNamesMap((prevMap) => ({
      ...prevMap,
      [key]: selectedCommentName,
    }));

    if (selectedCommentName?.comments) {
      setCommentsMap((prevMap) => ({
        ...prevMap,
        [key]: selectedCommentName.comments,
      }));
    }
  };

  useEffect(() => {
    if (!observationDataRedux || Object.keys(observationDataRedux).length === 0)
      return;

    const newCommentsMap = {};
    const newCommentNamesMap = {};
    const extractedDoctors = {};
    const newTemplateMap = {};

    Object.entries(observationDataRedux).forEach(
      ([department, investigations]) => {
        Object.entries(investigations).forEach(
          ([investigation_name, observationWrapper]) => {
            const key = `${department}-${investigation_name}`;
            const observations = observationWrapper?.observations || [];

            if (observations && observations.length > 0) {
              if (observationWrapper?.comments) {
                newCommentsMap[key] = observationWrapper.comments;
              } else {
                const firstObsWithComment = observations.find(
                  (obs) => obs?.comments,
                );

                newCommentsMap[key] = firstObsWithComment?.comments || "";
              }

              if (observationWrapper?.comment_obj) {
                newCommentNamesMap[key] = {
                  comment_id: observationWrapper.comment_obj.id,
                  comment_name: observationWrapper.comment_obj.comment_name,
                  comments: observationWrapper.comment_obj.comments,
                };
              } else {
                const obsWithCommentId = observations.find(
                  (obs) => obs?.comment_id,
                );
                if (obsWithCommentId) {
                  newCommentNamesMap[key] = {
                    comment_id: obsWithCommentId.comment_id,
                    comment_name: obsWithCommentId.comment_name || "",
                    comments: obsWithCommentId.comments || "",
                  };
                }
              }

              observations.forEach((obs) => {
                if (obs?.doctor_obj?.id) {
                  extractedDoctors[key] = obs.doctor_obj.id;
                }
              });

              const template_id =
                observationWrapper?.template_id || observations[0]?.template_id;
              const template_description =
                observationWrapper?.template_description ||
                observations[0]?.template_description ||
                "";

              if (template_id || template_description) {
                newTemplateMap[key] = {
                  template_id,
                  template_description,
                };
              }
            }
          },
        );
      },
    );

    setCommentsMap(newCommentsMap);
    setCommentNamesMap(newCommentNamesMap);
    setTemplate(newTemplateMap);

    const firstDoctorId = Object.values(extractedDoctors)[0];
    if (firstDoctorId) {
      setdoctorId(firstDoctorId);
    }
  }, [observationDataRedux]);

  const stripHtml = (html) => {
    if (!html || typeof html !== "string") return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  if (isLoadingPayment) {
    return <Loader isLoading={isLoadingPayment} />;
  }

  return (
    <>
      <div style={{ position: "relative" }}>
        {(isLoadingPayment || isLoading || isLoadingAdd) && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255, 255, 255, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
            }}
          >
            <Loader isLoading={true} />
          </div>
        )}

        <div
          style={{
            pointerEvents: "none",
            cursor: "not-allowed",
            textAlign: "left",
            display: "block",
            width: "100%",
          }}
        >
          {observationDataRedux &&
            Object.keys(observationDataRedux).length > 0 &&
            Object.entries(observationDataRedux).map(
              ([department, investigations]) =>
                Object.entries(investigations)
                  .filter(
                    ([investigation_name]) =>
                      investigation_name ===
                      rowData?.investigation_data?.investigation_name,
                  )
                  .map(([investigation_name, observationWrapper], index) => {
                    const investigationKey = `${department}-${investigation_name}`;
                    const observations = observationWrapper?.observations || [];
                    const investigationIds =
                      observations[0]?.investigation_details?.id || null;

                    return (
                      <div
                        key={`${department}-${investigation_name}`}
                        style={{ marginBottom: 20 }}
                      >
                        {observations?.map((observation, obsIndex) => {
                          const reportType =
                            observation?.investigation_details?.report_type;

                          return (
                            <div
                              key={obsIndex}
                              style={{ marginBottom: "10px" }}
                            >
                              {reportType === "Path RichText" ? (
                                <>
                                  <div className="col-md-4">
                                    <h5
                                      style={{
                                        fontSize: "13px",
                                        marginBottom: "5px",
                                        display: "flex",
                                      }}
                                    >
                                      Investigation Template
                                    </h5>
                                    <TemplateDropDown
                                      investigationId={investigationIds}
                                      setFilterValue={(val) =>
                                        setTemplate((prev) => ({
                                          ...prev,
                                          [investigationKey]: {
                                            ...prev[investigationKey],
                                            ...val,
                                          },
                                        }))
                                      }
                                      template={
                                        template[investigationKey] || {}
                                      }
                                    />
                                  </div>
                                  <div className="form-group mt-2">
                                    <label
                                      htmlFor="commentDesc"
                                      className="form-label d-flex"
                                    >
                                      Template Description
                                    </label>
                                    <TextEditor
                                      editorValue={
                                        template[investigationKey]
                                          ?.template_description || ""
                                      }
                                      height={400}
                                      setEditorValue={(val) =>
                                        setTemplate((prev) => ({
                                          ...prev,
                                          [investigationKey]: {
                                            ...prev[investigationKey],
                                            template_description: val,
                                          },
                                        }))
                                      }
                                    />
                                  </div>
                                </>
                              ) : (
                                <div key={obsIndex}>
                                  {obsIndex === 0 && (
                                    <Table
                                      data={observations}
                                      tableColumns={add_observation_columns}
                                      showPagination={false}
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })}

                        {isInvestigationCulture(
                          department,
                          investigation_name,
                        ) && (
                          <>
                            <div
                              style={{
                                width: "100%",
                                maxWidth: "100px",
                                marginTop: "10px",
                              }}
                            >
                              <select
                                style={{ width: "100%", padding: "5px" }}
                                onChange={(e) => {
                                  handleInvestigationChange(e);
                                  e.target.value = "";
                                }}
                              >
                                <option value="">- Select -</option>
                                {onlyOrganismData?.data?.data?.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.investigation_name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {selectedInvestigations.map((investigation) => (
                              <div
                                key={investigation.id}
                                style={{
                                  marginBottom: "20px",
                                  marginTop: "20px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "inline-flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "5px",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                    marginBottom: "5px",
                                    backgroundColor: "#f5f5f5",
                                    maxWidth: "400px",
                                    minWidth: "100px",
                                  }}
                                >
                                  <strong>{investigation.name}</strong>
                                  <button
                                    onClick={() =>
                                      handleRemoveInvestigation(
                                        investigation.id,
                                      )
                                    }
                                    style={{
                                      background: "red",
                                      color: "white",
                                      border: "none",
                                      padding: "3px 6px",
                                      cursor: "pointer",
                                      borderRadius: "3px",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    ✕
                                  </button>
                                </div>

                                {investigationDataMap[investigation.id] && (
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      padding: "5px",
                                      border: "1px solid #ddd",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    <Table
                                      data={
                                        investigationDataMap[investigation.id]
                                      }
                                      tableColumns={
                                        investigation_observation_columns
                                      }
                                      showPagination={false}
                                    />
                                  </div>
                                )}
                              </div>
                            ))}
                          </>
                        )}
                        <div className="row mt-2">
                          <div className="col-md-4">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: "8px",
                              }}
                            >
                              <h5 style={{ fontSize: "13px", margin: 0 }}>
                                Investigation Comments Name
                              </h5>

                              <button
                                onClick={() => setShowEditor(!showEditor)}
                                style={{
                                  backgroundColor: showEditor
                                    ? "#1890ff"
                                    : "#e6f7ff",
                                  border: "1px solid #1890ff",
                                  borderRadius: 6,
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 6,
                                  padding: "4px 10px",
                                  fontSize: 13,
                                  color: showEditor ? "#fff" : "#1890ff",
                                  fontWeight: "bold",
                                  transition: "all 0.2s ease-in-out",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    showEditor ? "#40a9ff" : "#bae7ff";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    showEditor ? "#1890ff" : "#e6f7ff";
                                }}
                              >
                                {showEditor ? (
                                  <>
                                    <FaEyeSlash size={16} />
                                    <span>Hide Editor</span>
                                  </>
                                ) : (
                                  <>
                                    <FaEye size={16} />
                                    <span>Show Editor</span>
                                  </>
                                )}
                              </button>
                            </div>
                            <CommentNameDropdown
                              investigationId={investigationIds}
                              value={commentNamesMap[investigationKey] || null}
                              setFilterValue={(selectedCommentName) =>
                                handleCommentNameChange(
                                  department,
                                  investigation_name,
                                  selectedCommentName,
                                )
                              }
                            />
                          </div>

                          {showEditor && (
                            <div className="col-md-8">
                              <TextEditor
                                editorValue={
                                  commentsMap[investigationKey] ?? ""
                                }
                                height={200}
                                setEditorValue={(val) =>
                                  handleCommentChange(
                                    department,
                                    investigation_name,
                                    val,
                                  )
                                }
                                showHeader={false}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  }),
            )}
        </div>

        <button
          className="btn btn-primary d-flex"
          onClick={() => editObservationValue(rowData)}
        >
          EDIT
        </button>

        <div className="form-group mt-2" style={{ marginTop: "10px" }}>
          <h5 style={{ fontSize: "13px" }} className="d-flex">
            Actions
          </h5>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {reportRoleData?.data?.only_roles_data &&
              Object.keys(reportRoleData.data.only_roles_data).map(
                (roleName) => {
                  const isDisabled =
                    roleName === "APPROVED" && !filterValue && !doctorId;

                  return (
                    <button
                      key={roleName}
                      type="button"
                      className="btn btn-primary"
                      disabled={isDisabled}
                      style={{
                        fontSize: "14px",
                        textTransform: "capitalize",
                      }}
                      onClick={() => {
                        if (roleName === "PREVIEW") {
                          const invId =
                            rowData?.invesigation_data?.investigation_id ||
                            rowData?.investigation_data?.investigation_id;
                          const appId = rowData?.appointment_id;

                          const url = `/ResultEntryPdf?display_header=true&display_footer_banner=false&display_banner=false&display_footer=true&display_address=true&display_watermark=true&investigation_ids=${invId}&appointment_id=${appId}`;

                          window.open(url, "_blank");
                        } else {
                          setStatus(roleName);
                          handleSave(roleName);
                        }
                      }}
                    >
                      {roleName}
                    </button>
                  );
                },
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ApprovedModalInsideRow;
